<template>
    <v-window v-model="profileEditionStep">
        <v-window-item transition="slide-x-transition" :value="'main'">
            <v-row no-gutters rounded>
                <v-col cols="12" rounded>
                    <v-list subheader lines="two">
                        <v-list-item
                            class="oss-list-item mb-2 mt-2"
                            @click.stop="profileEditionStep = 'openpoints'"
                        >
                            <template
                                v-slot:prepend
                                style="width: 48px"
                                class="my-0 d-flex justify-center"
                            >
                                <v-icon color="primary">$oss-analysis</v-icon>
                            </template>
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title> Gestion des en cours </v-list-item-title
                            ><v-list-item-subtitle>{{
                                subTitleOpenpoints
                            }}</v-list-item-subtitle></v-list-item
                        >
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click.stop="profileEditionStep = 'payments'"
                        >
                            <template
                                v-slot:prepend
                                style="width: 48px"
                                class="my-0 d-flex justify-center"
                            >
                                <v-icon color="primary">$oss-bank</v-icon>
                            </template>
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title> Gestion des paiements </v-list-item-title
                            ><v-list-item-subtitle>{{
                                subTitlePayments
                            }}</v-list-item-subtitle></v-list-item
                        >
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click.stop="profileEditionStep = 'validation'"
                        >
                            <template
                                v-slot:prepend
                                style="width: 48px"
                                class="my-0 d-flex justify-center"
                            >
                                <v-icon color="primary">$fa-file-contract</v-icon>
                            </template>
                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title> Gestion de la validation </v-list-item-title
                            ><v-list-item-subtitle>{{ subTitleValidation }}</v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-window-item>

        <!-- OPEN POINTS -->
        <v-window-item transition="slide-x-transition" :value="'openpoints'">
            <v-row no-gutters>
                <v-col cols="12" class="rounded">
                    <v-btn-back @click.stop="profileEditionStep = 'main'"> </v-btn-back>
                    <span class="title ml-2">Gestion des en cours</span>
                    <v-list subheader class="mt-2" lines="two">
                        <v-list-item
                            class="oss-list-item mb-2 mt-2"
                            @click.stop="profileEditionStep = 'openpoints-clients'"
                        >
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-building</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                            <v-list-item-title>Clients </v-list-item-title
                            ><v-list-item-subtitle>{{
                                subTitleOpenpointsCustomer
                            }}</v-list-item-subtitle></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-building</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.outstanding.supplier"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Fournisseurs </v-list-item-title></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$oss-expense-report</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.outstanding.expenseReport"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Note de frais </v-list-item-title></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-hand-holding-usd</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.outstanding.salary"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Salaire </v-list-item-title></v-list-item
                        >
                    </v-list>
                </v-col>
            </v-row>
        </v-window-item>
        <v-window-item transition="slide-x-transition" :value="'openpoints-clients'">
            <v-row no-gutters class="py-2">
                <v-col cols="6">
                    <v-btn-back @click.stop="profileEditionStep = 'openpoints'" v-if="!invoiceMode">
                    </v-btn-back>
                    <span class="title ml-2">Encours Clients </span>
                </v-col>
                <v-col cols="3" class="d-flex align-center">
                    <v-switch
                        v-model="outstandingClient"
                        hide-details
                        class="my-0"
                        label="Activer pour tous les clients"
                        v-tooltip="'y compris les futurs clients créés'"
                        :ripple="false"
                        :readonly="!isEditable"
                    />
                </v-col>
                <v-col v-if="invoiceMode" cols="2" class="d-flex align-end justify-end">
                    <v-btn
                        rounded
                        elevation="0"
                        :disabled="!isEditable"
                        @click="upsertCompanyUser()"
                        size="small"
                    >
                        Enregistrer
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters class="py-2" v-if="!outstandingClient">
                <v-col cols="4">
                    <v-text-field-filled
                        v-model="clientSearch"
                        label="Rechercher"
                        append-inner-icon="$search"
                        outlined
                        hide-details
                        density="compact"
                        clearable
                        @click:clear="clientSearch = ''"
                    />
                </v-col>
                <v-col class="pl-2 d-flex align-center">
                    <template v-if="selectedClients.length > 0">
                        <v-btn @click="diselectAllClients()" size="small" :disabled="!isEditable">
                            Aucun client
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn
                            class="mr-2"
                            @click="selectAllClients()"
                            size="small"
                            :disabled="!isEditable"
                        >
                            Sélectionner tous les clients
                        </v-btn>
                    </template>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <template v-if="!pairedClientCompanies.length">
                    <v-col cols="12"> Aucun client trouvé </v-col>
                </template>
                <template v-else-if="outstandingClient">
                    <v-col cols="12"> Tous les clients sont sélectionnés </v-col>
                </template>
                <!-- <template v-else>
                    <v-col
                        cols="6"
                        v-for="comp in clientCompanies"
                        :key="comp.id"
                        class="pr-2 pb-2"
                    >
                        <v-list-item :ripple="false" class="oss-list-item" readonly>
                            <template v-slot:append>
                                <v-checkbox
                                    v-model="selectedClients"
                                    class="pa-0 ma-0"
                                    @click.stop
                                    :value="comp.id"
                                    :disabled="!isEditable"
                                />
                            </template>

                            <v-list-item-title>
                                <span>{{ comp.name }}</span> </v-list-item-title
                            ><v-list-item-subtitle>
                                {{ getSiretValue(comp.siret) }}
                            </v-list-item-subtitle></v-list-item
                        >
                    </v-col>
                </template> -->
                <template v-else>
                    <v-col>
                        <v-virtual-scroll
                            :items="pairedClientCompanies"
                            :item-height="66"
                            :height="`min(${pairedClientCompanies.length * 66}px, calc(100vh - 280px) )`"
                            width="100%"
                        >
                            <template v-slot="{ item }">
                                <v-row no-gutters>
                                    <v-col
                                        cols="6"
                                        v-for="comp in item"
                                        :key="comp.id"
                                        class="pr-2 pb-2"
                                    >
                                        <v-list-item :ripple="false" class="oss-list-item" readonly>
                                            <template v-slot:append>
                                                <v-checkbox
                                                    v-model="selectedClients"
                                                    class="pa-0 ma-0"
                                                    @click.stop
                                                    :value="comp.id"
                                                    :disabled="!isEditable"
                                                />
                                            </template>

                                            <v-list-item-title>
                                                <span>{{ comp.name }}</span> </v-list-item-title
                                            ><v-list-item-subtitle>
                                                {{ getSiretValue(comp.siret) }}
                                            </v-list-item-subtitle></v-list-item
                                        >
                                    </v-col>
                                </v-row>
                            </template>
                        </v-virtual-scroll>
                    </v-col>
                </template>
            </v-row>
        </v-window-item>

        <!-- PAYEMENT -->
        <v-window-item transition="slide-x-transition" :value="'payments'">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-btn-back @click.stop="profileEditionStep = 'main'"> </v-btn-back>
                    <span class="title ml-2">Gestion des paiements</span>
                    <v-list subheader class="mt-2" lines="two">
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-building</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.payments.supplier"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Fournisseurs </v-list-item-title></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$oss-expense-report</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.payments.expenseReport"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Note de frais </v-list-item-title></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-hand-holding-usd</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.payments.salary"
                                    hide-details
                                    class="my-0"
                                    :ripple="false"
                                    :readonly="!isEditable"
                                />
                            </template>
                            <v-list-item-title> Salaire </v-list-item-title></v-list-item
                        >
                    </v-list>
                </v-col>
            </v-row>
        </v-window-item>

        <!-- VALIDATION -->
        <v-window-item transition="slide-x-transition" :value="'validation'">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-btn-back @click.stop="profileEditionStep = 'main'"> </v-btn-back>
                    <span class="title ml-2">Gestion de la validation</span>
                    <v-list subheader class="mt-2" lines="two">
                        <v-list-item class="oss-list-item mb-2">
                            <template v-slot:prepend style="width: 48px" class="my-0">
                                <v-icon color="primary">$fa-building</v-icon>
                            </template>

                            <template v-slot:append class="my-0">
                                <v-switch
                                    v-model="companyUser.configuration.validation.supplier"
                                    hide-details
                                    class="my-0"
                                    :readonly="!isEditable"
                                    :ripple="false"
                                />
                            </template>
                            <v-list-item-title> Fournisseurs </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import UPSERT_COMPANY_USER from "../../graphql/user/UpsertCompanyUser.gql";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import { defaultCompanyUser } from "@/services/user/companyUser";
import _ from "lodash";

import { getSiretValue } from "../../../src/services/companyServices";
import { Component, Vue, toNative, Prop, Watch } from "vue-facing-decorator";

@Component({
    emits: ["updatedCompanyUser"],
})
export class ProfileManagement extends Vue {
    @Prop({ default: () => ({}) }) companyUser!: any;
    @Prop({ default: () => ({}) }) companyId!: any;
    @Prop({ default: () => ({}) }) user!: any; // mandatory only if invoice_Mode is true
    @Prop({ default: false }) inComponent!: boolean;
    @Prop({ default: false }) invoiceMode!: boolean;

    profileEditionStep = "main";

    clientSearch = "";

    selectedClients = [];

    beforeMount() {
        if (this.invoiceMode) {
            this.profileEditionStep = "openpoints-clients";
        }
        // Use case where the companyUser has not been create for the user for the company
        if (!this.companyUser && !this.companyUser?.id) {
            this.companyUser = _.cloneDeep(defaultCompanyUser);
        }

        if (this.companyUser?.clients?.length) {
            this.selectedClients = this.companyUser.clients.map((c) => c.id);
        }
    }

    get outstandingClient() {
        return this.companyUser?.configuration?.outstanding?.client;
    }

    set outstandingClient(value) {
        if (this.companyUser?.configuration?.outstanding) {
            this.companyUser.configuration.outstanding.client = value;
        }
        if (value) {
            this.diselectAllClients();
        }
    }

    get isEditable() {
        return this.currentUser?.profile?.configuration?.outstanding?.otherUserAccess || false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get subTitleOpenpointsCustomer() {
        if (this.outstandingClient) {
            return "Tous les clients";
        }
        if (this.companyUser.clients.length) {
            return `${this.companyUser.clients.length} ${
                this.companyUser.clients.length > 1 ? "clients sélectionnés" : "client sélectionné"
            }`;
        }
        return "Aucun client sélectionné";
    }

    get subTitleOpenpoints() {
        const subtitles = [];
        if (this.outstandingClient) {
            subtitles.push("tous les clients");
        } else if (this.companyUser.clients.length) {
            subtitles.push(
                `${this.companyUser.clients.length} ${
                    this.companyUser.clients.length > 1 ? "clients" : "client"
                }`,
            );
        }

        if (this.companyUser.configuration.outstanding.supplier) {
            subtitles.push(`tous les fournisseurs`);
        }

        if (this.companyUser.configuration.outstanding.expenseReport) {
            subtitles.push(`toutes les notes de frais`);
        }

        if (this.companyUser.configuration.outstanding.salary) {
            subtitles.push(`tous les salaires`);
        }

        if (subtitles.length) {
            return `Accès à ${subtitles.join(", ")}`;
        }
        return "Aucun accès";
    }

    get subTitleValidation() {
        const subtitles = [];

        // if (this.companyUser.configuration.validation.supplier) {
        //     subtitles.push(`tous les fournisseurs`)
        // }

        if (subtitles.length) {
            return `Validation des factures de ${subtitles.join(", ")}`;
        }
        return "Aucun accès";
    }

    get subTitlePayments() {
        const subtitles = [];

        // if (this.companyUser.configuration.payments.supplier) {
        //     subtitles.push(`des fournisseurs`)
        // }

        // if (this.companyUser.configuration.payments.expenseReport) {
        //     subtitles.push(`des notes de frais`)
        // }

        // if (this.companyUser.configuration.payments.salary) {
        //     subtitles.push(`des salaires`)
        // }

        if (subtitles.length) {
            return `Paiement ${subtitles.join(", ")}`;
        }
        return "Aucun accès";
    }

    get clientLoading() {
        if (this.$apollo.queries.pairedClientCompanies) {
            return this.$apollo.queries.pairedClientCompanies.loading;
        }
        return false;
    }

    @Apollo({
        query: CUSTOMER_COMPANIES,
        variables() {
            return {
                companyId: this.companyId,
                search: this.clientSearch,
            };
        },
        skip() {
            return this.outstandingClient || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    console.log("data", data);
                    if (data.customerCompanies && data.customerCompanies.length) {
                        const newPairedClientCompanies = [];
                        let newpairedClient = [];
                        for (const cCIndex in data.customerCompanies) {
                            if (parseInt(cCIndex) % 2) {
                                newpairedClient.push(data.customerCompanies[cCIndex]);
                                newPairedClientCompanies.push(newpairedClient);
                                newpairedClient = [];
                            } else {
                                newpairedClient.push(data.customerCompanies[cCIndex]);
                            }
                        }
                        if (data.customerCompanies.length % 2 === 1) {
                            newPairedClientCompanies.push(newpairedClient);
                        }
                        this.pairedClientCompanies = newPairedClientCompanies;
                        // this.clientCompanies = data.customerCompanies;
                        if (!this.selectedClients?.length && this.companyUser?.clients.length) {
                            this.selectedClients = this.companyUser.clients.map((c) => c.id);
                        }
                    } else {
                        this.pairedClientCompanies = [];
                        // this.clientCompanies = [];
                    }
                }
            }
        },
    })
    pairedClientCompanies: Array<Array<any>> = [];
    // clientCompanies: Array<any> = [];

    async upsertCompanyUser() {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_COMPANY_USER,
            variables: {
                id: this.companyUser.id,
                companyId: this.companyId,
                userId: this.invoiceMode ? this.currentUser.id : this.user.id,
                createProfile:
                    this.companyUser.profile && this.companyUser.profile.id
                        ? { connect: { id: this.companyUser.profile.id } }
                        : undefined,
                updateProfile:
                    this.companyUser.profile && this.companyUser.profile.id
                        ? { connect: { id: this.companyUser.profile.id } }
                        : undefined,
                investment: this.companyUser.investment,
                role: this.companyUser.role !== "UNKNOWN" ? this.companyUser.role : null,
                legalRepresentativeType: this.companyUser.legalRepresentativeType,
                accountingLegalRepresentative: this.companyUser.accountingLegalRepresentative,
                configuration: this.companyUser.configuration,
                clients: this.companyUser?.clients?.map((c) => ({ id: c.id })) || [],
                accessRights: this.companyUser?.accessRights?.map((ar) => ({ id: ar.id })) || [],
                partOfCompany: this.companyUser.partOfCompany,
            },
        });
        // const result = await this.$apollo.mutate({
        //     mutation: gql`
        //         mutation UpsertCompanyUser(
        //             $id: ID!
        //             $companyId: ID!
        //             $userId: ID!
        //             $investment: Json
        //             $createProfile: ProfileCreateOneInput
        //             $updateProfile: ProfileUpdateOneInput
        //             $role: CompanyUserRole
        //             $legalRepresentativeType: CompanyUserLegalRepresentativeType
        //             $accountingLegalRepresentative: Boolean
        //             $configuration: Json
        //             $clients: [CompanyWhereUniqueInput!]
        //             $accessRights: [TagWhereUniqueInput!]
        //         ) {
        //             upsertCompanyUser(
        //                 where: { id: $id }
        //                 create: {
        //                     company: { connect: { id: $companyId } }
        //                     user: { connect: { id: $userId } }
        //                     investment: $investment
        //                     profile: $createProfile
        //                     role: $role
        //                     legalRepresentativeType: $legalRepresentativeType
        //                     accountingLegalRepresentative: $accountingLegalRepresentative
        //                     configuration: $configuration
        //                     clients: { connect: $clients }
        //                     accessRights: { connect: $accessRights }
        //                 }
        //                 update: {
        //                     # company: { connect: { id: $companyId }}
        //                     # user: { connect: { id: $userId }}
        //                     investment: $investment
        //                     profile: $updateProfile
        //                     role: $role
        //                     legalRepresentativeType: $legalRepresentativeType
        //                     accountingLegalRepresentative: $accountingLegalRepresentative
        //                     configuration: $configuration
        //                     clients: { set: $clients }
        //                     accessRights: { set: $accessRights }
        //                 }
        //             ) {
        //                 id
        //             }
        //         }
        //     `,
        //     variables: {
        //         id: this.companyUser.id || "",
        //         companyId: this.companyId,
        //         userId: this.invoiceMode ? this.currentUser.id : this.user.id,
        //         createProfile:
        //             this.companyUser.profile && this.companyUser.profile.id
        //                 ? { connect: { id: this.companyUser.profile.id } }
        //                 : undefined,
        //         updateProfile:
        //             this.companyUser.profile && this.companyUser.profile.id
        //                 ? { connect: { id: this.companyUser.profile.id } }
        //                 : undefined,
        //         investment: this.companyUser.investment,
        //         role: this.companyUser.role !== "UNKNOWN" ? this.companyUser.role : null,
        //         legalRepresentativeType: this.companyUser.legalRepresentativeType,
        //         accountingLegalRepresentative: this.companyUser.accountingLegalRepresentative,
        //         configuration: this.companyUser.configuration,
        //         clients: this.companyUser?.clients?.map((c) => ({ id: c.id })) || [],
        //         accessRights: this.companyUser?.accessRights?.map((ar) => ({ id: ar.id })) || [],
        //     },
        // });
        if (result?.data?.upsertCompanyUser?.id) {
            this.companyUser.id = result.data.upsertCompanyUser.id;
        } else {
            debugger; // git-ignore
        }
    }

    selectAllClients() {
        this.selectedClients = this.pairedClientCompanies
            .reduce((a, b) => a.concat(b), [])
            .map((c) => c.id);
        //this.clientCompanies.map((c) => c.id);
    }

    diselectAllClients() {
        this.selectedClients = [];
    }

    @Watch("companyUser.clients", { deep: true })
    onOutstandingSelectionCustomerChanged() {
        if (this.companyUser.clients.length) {
            this.companyUser.configuration.outstanding.client = false;
            this.companyUser.configuration.outstanding.selectionClient = true;
        } else if (!this.companyUser.clients.length) {
            this.companyUser.configuration.outstanding.selectionClient = false;
        }
    }

    // onOutstandingCustomerChanged(value) {
    //     if (this.companyUser.configuration.outstanding.client) {
    //         this.companyUser.configuration.outstanding.selectionClient = false;
    //         this.diselectAllClients();
    //     } else {
    //     }
    // }

    @Watch("companyUser", { deep: true })
    onCompanyUserConfigurationChanged() {
        if (this.inComponent) {
            this.$emit("updatedCompanyUser", this.companyUser);
        }
    }

    // onCustomerClicked(client) {
    //     debugger
    //     this.companyUser.configuration.outstanding.client = false
    //     const isSelected = this.isSelectedCustomer(client.id)
    //     if (isSelected) {
    //         this.companyUser.clients = this.companyUser.clients.filter((x) => x.id !== client.id)
    //     } else {
    //         this.companyUser.clients.push(client)
    //     }
    // }

    @Watch("selectedClients", { deep: true })
    onSelectedClientsChanged() {
        this.companyUser.clients = this.pairedClientCompanies
            .flat()
            .filter((comp) => this.selectedClients.includes(comp.id));
        // this.updateCompanyUserClients();
    }

    @Watch("search")
    onSearchModified() {
        this.pairedClientCompanies = [];
        // this.firstRequestDone = false;
        // this.clientCompanies = [];
        // this.pagination.page = 1;
    }

    // updateCompanyUserClients() {
    //     this.companyUser.clients = this.pairedClientCompanies
    //         .flat()
    //         .filter((comp) => selectedClientIds.includes(comp.id));
    //     debugger;
    // }

    // isSelectedCustomer(clientId) {
    //     const isSelected = this.companyUser.clients.findIndex(x => x.id === clientId)
    //     return isSelected !== -1
    // }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(ProfileManagement);
</script>

<style scoped>
/* Add your styles here */
</style>
